import React, { useState } from 'react';
import Role from './Pages/role';
import Login from './Pages/login';
import StudentPath from './Pages/student_path';
import Board from './Pages/board';
import Grade from './Pages/grade';
import Exam from './Pages/exam';
import Dashboard from './Pages/dashboard';
import AllCourses from './Pages/all_courses';
import CourseDetails from './Pages/course_details';
import MyCourse from './Pages/my_course';
import BoughtCourse from './Pages/bought_course';
import StudyScreen from './Pages/study_screen';
import Parent from './Pages/parent';
import AdminLogin from './Pages/admin_login';
import AdminDashboard from './Pages/admin_dashboard';
import AdminCourse from './Pages/admin_course';
import AdminChapter from './Pages/admin_chapter';
import AdminQuestion from './Pages/admin_question';
import AdminStudent from './Pages/admin_student';
import AdminParent from './Pages/admin_parent';
import AdminRevenue from './Pages/admin_revenue';
import './App.css';

function App() {
  const [view, setView] = useState('role');

  const handleStudentPathContinue = (path) => {
    if (path === 'curriculum') {
      setView('board');
    } else if (path === 'competitive') {
      setView('exam');
    }
  };

  return (
    <div className="App">
      {view === 'role' && (
        <Role
          onContinue={() => setView('login')}
          onSelectParent={() => setView('parent')}
          onAdminLogin={() => setView('admin_login')}
        />
      )}
      {view === 'login' && (
        <Login onLogin={() => setView('student_path')} onBack={() => setView('role')} />
      )}
      {view === 'student_path' && (
        <StudentPath onContinue={handleStudentPathContinue} onBack={() => setView('login')} />
      )}
      {view === 'board' && (
        <Board onContinue={() => setView('grade')} onBack={() => setView('student_path')} />
      )}
      {view === 'grade' && (
        <Grade onContinue={() => setView('dashboard')} onBack={() => setView('board')} />
      )}
      {view === 'exam' && (
        <Exam onContinue={() => setView('dashboard')} onBack={() => setView('student_path')} />
      )}
      {view === 'dashboard' && (
        <Dashboard
          onNavigateToAllCourses={() => setView('all_courses')}
          onNavigateToMyCourses={() => setView('my_course')}
          onBack={() => setView('student_path')}
        />
      )}
      {view === 'all_courses' && (
        <AllCourses onSelectCourse={() => setView('course_details')} onBack={() => setView('dashboard')} />
      )}
      {view === 'course_details' && (
        <CourseDetails onBack={() => setView('all_courses')} />
      )}
      {view === 'my_course' && (
        <MyCourse onBack={() => setView('dashboard')} onSelectCourse={() => setView('bought_course')} />
      )}
      {view === 'bought_course' && (
        <BoughtCourse onBack={() => setView('my_course')} onContinueLearning={() => setView('study_screen')} />
      )}
      {view === 'study_screen' && (
        <StudyScreen onBack={() => setView('bought_course')} />
      )}
      {view === 'parent' && (
        <Parent onBack={() => setView('role')} />
      )}
      {view === 'admin_login' && (
        <AdminLogin onLogin={() => setView('admin_dashboard')} onBack={() => setView('role')} />
      )}
      {view === 'admin_dashboard' && (
        <AdminDashboard
          onDashboard={() => setView('admin_dashboard')}
          onCourseManagement={() => setView('admin_course')}
          onChapterManagement={() => setView('admin_chapter')}
          onQuestionBank={() => setView('admin_question')}
          onStudentDirectory={() => setView('admin_student')}
          onParentDirectory={() => setView('admin_parent')}
          onRevenue={() => setView('admin_revenue')}
          onLogout={() => setView('admin_login')}
        />
      )}
      {view === 'admin_course' && (
        <AdminCourse
          onDashboard={() => setView('admin_dashboard')}
          onCourseManagement={() => setView('admin_course')}
          onChapterManagement={() => setView('admin_chapter')}
          onQuestionBank={() => setView('admin_question')}
          onStudentDirectory={() => setView('admin_student')}
          onParentDirectory={() => setView('admin_parent')}
          onRevenue={() => setView('admin_revenue')}
          onLogout={() => setView('admin_login')}
          onBack={() => setView('admin_dashboard')}
        />
      )}
      {view === 'admin_chapter' && (
        <AdminChapter
          onDashboard={() => setView('admin_dashboard')}
          onCourseManagement={() => setView('admin_course')}
          onChapterManagement={() => setView('admin_chapter')}
          onQuestionBank={() => setView('admin_question')}
          onStudentDirectory={() => setView('admin_student')}
          onParentDirectory={() => setView('admin_parent')}
          onRevenue={() => setView('admin_revenue')}
          onLogout={() => setView('admin_login')}
          onBack={() => setView('admin_dashboard')}
        />
      )}
      {view === 'admin_question' && (
        <AdminQuestion
          onDashboard={() => setView('admin_dashboard')}
          onCourseManagement={() => setView('admin_course')}
          onChapterManagement={() => setView('admin_chapter')}
          onQuestionBank={() => setView('admin_question')}
          onStudentDirectory={() => setView('admin_student')}
          onParentDirectory={() => setView('admin_parent')}
          onRevenue={() => setView('admin_revenue')}
          onLogout={() => setView('admin_login')}
          onBack={() => setView('admin_dashboard')}
        />
      )}
      {view === 'admin_student' && (
        <AdminStudent
          onDashboard={() => setView('admin_dashboard')}
          onCourseManagement={() => setView('admin_course')}
          onChapterManagement={() => setView('admin_chapter')}
          onQuestionBank={() => setView('admin_question')}
          onStudentDirectory={() => setView('admin_student')}
          onParentDirectory={() => setView('admin_parent')}
          onRevenue={() => setView('admin_revenue')}
          onLogout={() => setView('admin_login')}
          onBack={() => setView('admin_dashboard')}
        />
      )}
      {view === 'admin_parent' && (
        <AdminParent
          onDashboard={() => setView('admin_dashboard')}
          onCourseManagement={() => setView('admin_course')}
          onChapterManagement={() => setView('admin_chapter')}
          onQuestionBank={() => setView('admin_question')}
          onStudentDirectory={() => setView('admin_student')}
          onParentDirectory={() => setView('admin_parent')}
          onRevenue={() => setView('admin_revenue')}
          onLogout={() => setView('admin_login')}
          onBack={() => setView('admin_dashboard')}
        />
      )}
      {view === 'admin_revenue' && (
        <AdminRevenue
          onDashboard={() => setView('admin_dashboard')}
          onCourseManagement={() => setView('admin_course')}
          onChapterManagement={() => setView('admin_chapter')}
          onQuestionBank={() => setView('admin_question')}
          onStudentDirectory={() => setView('admin_student')}
          onParentDirectory={() => setView('admin_parent')}
          onRevenue={() => setView('admin_revenue')}
          onLogout={() => setView('admin_login')}
          onBack={() => setView('admin_dashboard')}
        />
      )}

    </div>
  );
}

export default App;
